import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


//Pipe
import { ProfilePicturePipe } from './profilePicture/profilePicture.pipe';
import { ChatPersonSearchPipe } from './search/chat-person-search.pipe';
import { UserSearchPipe } from './search/user-search.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { MailSearchPipe } from './search/mail-search.pipe';
import { SearchKeySearchPipe } from './search/searchkey-search.pipe';
import { FilterPipe } from './search/filter.pipe';
import { CustomersSearchPipe } from './search/customer-search.pipe';
import { BookingSearchPipe} from './search/booking-search.pipe';
import { DefaultRateSearchPipe} from './search/defaultrate-search.pipe';
import { JobSearchPipe} from './search/job-search.pipe';
import { ContactSearchPipe} from './search/contact-search.pipe';
import { MemberSearchPipe } from './search/member-search.pipe';
import { DocumentsSearchPipe } from './search/document-search.pipe';
import { FleetSearchPipe } from './search/fleet-search.pipe';
import { DispatchSearchPipe } from './search/dispatch-search.pipe';
import { JobNotificationSearchPipe} from './search/jobnotification-search.pipe';
import { OrdinalPipe } from './read/ordinal.pipe';
import { RunActionPipe } from './read/run-action.pipe';
import { ConnoteControlNoPipe } from './read/connote-control-no.pipe';
import { ReadLocationPipe } from './read/read-location.pipe';
import { DriverNamePipe } from './read/driver-name.pipe';
import { RunTypeNamePipe } from './read/run-type-name.pipe';
import { DriverLicensePipe } from './read/driver-license.pipe';
import { RunServiceTypeNamePipe } from './read/service-type-name.pipe';


@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        SearchKeySearchPipe,
        FilterPipe,
        CustomersSearchPipe,
        BookingSearchPipe,
        DefaultRateSearchPipe,
        JobSearchPipe,
        ContactSearchPipe,
        MemberSearchPipe,
        DocumentsSearchPipe,
        FleetSearchPipe,
        DispatchSearchPipe,
        JobNotificationSearchPipe,
        OrdinalPipe,
        RunActionPipe,
        ConnoteControlNoPipe,
        ReadLocationPipe,
        DriverNamePipe,
        RunTypeNamePipe,
        DriverLicensePipe,
        RunServiceTypeNamePipe
    ],
    exports: [
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        SearchKeySearchPipe,
        FilterPipe,
        CustomersSearchPipe,
        BookingSearchPipe,
        DefaultRateSearchPipe,
        JobSearchPipe,
        ContactSearchPipe,
        MemberSearchPipe,
        DocumentsSearchPipe,
        FleetSearchPipe,
        DispatchSearchPipe,
        JobNotificationSearchPipe,
        OrdinalPipe,
        RunActionPipe,
        ConnoteControlNoPipe,
        ReadLocationPipe,
        DriverNamePipe,
        RunTypeNamePipe,
        DriverLicensePipe,
        RunServiceTypeNamePipe
    ]
})
export class PipesModule { }
